import * as importActions from '../actions/import.actions';
import { createFeatureSelector } from '@ngrx/store';

export interface ImportState {
  importExport: any;
  loading: boolean;
  loaded: boolean;
  addSuccess: boolean;
  error: any;
}

const initialState = {
  importExport: null,
  loading: false,
  loaded: false,
  addSuccess: null,
  error: null
};

export const importReducer = (state = initialState, action) => {
  switch (action.type) {
    case importActions.GET_IMPORT_LIST:
      return {
        ...state,
        error: null,
        loading: true,
        loaded: state.loaded
      };
    case importActions.GET_IMPORT_LIST_SUCCESS:
      return {
        ...state,
        importExport: action.payload,
        error: null,
        loading: false,
        loaded: true,
      };
    case importActions.GET_IMPORT_LIST_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
        loaded: false
      };
    case importActions.ADD_IMPORT_JOB_SUCCESS:
      const newImport = action.payload;
      let importExport = null;
      if (state.importExport) {
        importExport = {
          items: [newImport, ...state.importExport.items],
          pageCount: state.importExport.pageCount,
          recordCount: state.importExport.recordCount
        };
      } else {
        importExport = {
          items: [...state.importExport.items],
          pageCount: 1,
          recordCount: state.importExport.recordCount
        };
      }
      return {
        ...state,
        error: null,
        addSuccess: true,
        importExport: importExport
      };
    case importActions.ADD_IMPORT_JOB_FAIL:
      return {
        ...state,
        error: action.payload,
        addSuccess: false,
      };

    case importActions.RESET_IMPORT_CRUD:
      return {
        ...state,
        error: null,
        addSuccess: null,
        loading: null,
        loaded: null,
      };
    case importActions.CLEAR_IMPORT_LIST:
      return {
        ...state,
        error: null,
        importExport: null,
        loading: false,
        loaded: false
      };
    default:
      return state;
  }
};

export const getImportState = createFeatureSelector<ImportState>('importReducer');

export const getImportList = (state: ImportState) => state.importExport;
export const getImportListLoaded = (state: ImportState) => state.loaded;
export const getImportAddNewStatus = (state: ImportState) => state.addSuccess;
